export default {"src":"/_next/static/media/density.6b224f44.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};